import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

const COMPANY = {
  brand: "MİLYEMSOFT",
  legalName: "Mustafa Yıldız (Şahıs İşletmesi)",
  address: "Reyhanlı, Hatay / Türkiye",
  phone: "0534 964 67 03",
  email: "milyemsoft@gmail.com",
  website: "milyemsoft.com",
};

export { COMPANY };

/**
 * Shared premium wrapper for all legal / policy pages.
 * - Sticky top bar with brand + back-home link
 * - Two-column grid on desktop (sidebar w/ meta, content column)
 * - Print-friendly typography scale
 */
export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen text-white" style={{
      background: "radial-gradient(ellipse at top, #0a0a0a 0%, #030303 60%)",
    }}>
      {/* Top nav */}
      <header className="sticky top-0 z-30 border-b border-white/8 backdrop-blur-xl" style={{ background: "rgba(4,4,4,0.85)" }}>
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="font-display text-lg tracking-widest" style={{ color: "var(--gold)" }} data-testid="legal-brand-home">
            {COMPANY.brand.toUpperCase()}
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-mono tracking-wider text-neutral-400 hover:text-white transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={14} /> ANA SAYFA
          </Link>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-6xl mx-auto px-6 sm:px-10 py-14 lg:py-20 grid gap-14 lg:grid-cols-[240px_1fr]">
        {/* Sidebar meta */}
        <aside className="lg:sticky lg:top-24 h-fit space-y-6">
          <div>
            <div className="text-[10px] font-mono tracking-[0.3em] uppercase" style={{ color: "var(--gold)" }}>
              {eyebrow}
            </div>
            <h1 className="font-display text-3xl sm:text-4xl mt-3 leading-tight">{title}</h1>
            {updated && (
              <div className="mt-4 text-[11px] font-mono tracking-wider text-neutral-500">
                Son güncelleme: {updated}
              </div>
            )}
          </div>
          <div className="border border-white/8 p-4 text-xs leading-relaxed text-neutral-400">
            <div className="label-caps mb-2">İşletme</div>
            <div className="text-white">{COMPANY.legalName}</div>
            <div className="mt-1">{COMPANY.address}</div>
            <div className="mt-1">Tel: {COMPANY.phone}</div>
            <div className="mt-1">E-posta: <a href={`mailto:${COMPANY.email}`} className="hover:text-[--gold]" style={{color:"var(--gold)"}}>{COMPANY.email}</a></div>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-mono tracking-wider text-neutral-400 hover:text-white"
          >
            <Home size={13} /> geri dön
          </Link>
        </aside>

        {/* Content */}
        <article className="legal-prose space-y-5 text-neutral-300 leading-[1.75]" data-testid="legal-content">
          {children}
        </article>
      </main>

      <style>{`
        .legal-prose h2 { color: #fff; font-family: var(--font-display, serif); font-size: 1.5rem; margin-top: 2rem; margin-bottom: 0.75rem; letter-spacing: 0.02em; }
        .legal-prose h3 { color: #fff; font-size: 1.1rem; margin-top: 1.5rem; margin-bottom: 0.5rem; font-weight: 500; }
        .legal-prose p  { margin-bottom: 0.9rem; font-size: 0.95rem; }
        .legal-prose ul { list-style: none; padding-left: 0; margin-bottom: 1rem; }
        .legal-prose li { position: relative; padding-left: 1.25rem; margin-bottom: 0.4rem; font-size: 0.95rem; }
        .legal-prose li:before { content: "—"; position: absolute; left: 0; color: var(--gold); }
        .legal-prose strong { color: #fff; font-weight: 500; }
        .legal-prose a { color: var(--gold); text-decoration: none; border-bottom: 1px dotted rgba(212,175,55,0.5); }
        .legal-prose a:hover { border-bottom-style: solid; }
      `}</style>
    </div>
  );
}
